import { render } from "./CZScannedInvoices.vue?vue&type=template&id=4205c057&scoped=true&ts=true"
import script from "./CZScannedInvoices.vue?vue&type=script&lang=ts"
export * from "./CZScannedInvoices.vue?vue&type=script&lang=ts"

import "./CZScannedInvoices.vue?vue&type=style&index=0&id=4205c057&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4205c057"]])

export default __exports__